<!-- 中期报告 -->
<template>
  <svg
    v-if="modelValue == 0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.2 34.35"
    class="notStarted"
  >
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="25.75" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="25.75" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M27.82,3V2.68a1.7,1.7,0,0,0-1.76-1.63H9A1.7,1.7,0,0,0,7.25,2.69V25.84A1.7,1.7,0,0,0,9,27.47h9.75a.24.24,0,0,0,.25-.31c-.46-1.27-1.93-6.18,1.18-8.75a8.33,8.33,0,0,1,7.63-1.65c.06,0,.14-.2.13-.6,0-.83,0-4-.05-5.88"
        />
        <line class="cls-4" x1="9.98" y1="9.4" x2="23.49" y2="9.4" />
        <line class="cls-4" x1="9.98" y1="12.95" x2="23.49" y2="12.95" />
        <line class="cls-4" x1="9.98" y1="17.29" x2="14.75" y2="17.29" />
        <line class="cls-5" x1="24.66" y1="20.27" x2="24.66" y2="27.58" />
        <rect
          class="cls-5"
          x="21.28"
          y="22.21"
          width="6.76"
          height="2.61"
          rx="0.8"
        />
        <circle class="cls-6" cx="27.96" cy="6.26" r="1.3" />
      </g>
    </g>
  </svg>
  <svg
    v-if="modelValue == 1"
    class="inProgress"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.2 38.34"
  >
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.74" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.74" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M29.13,3.4V3a1.94,1.94,0,0,0-2-1.87H7.56A2,2,0,0,0,5.55,3V29.56a2,2,0,0,0,2,1.88H18.75a.28.28,0,0,0,.28-.36c-.52-1.46-2.22-7.09,1.35-10a9.54,9.54,0,0,1,8.75-1.89c.07,0,.16-.24.15-.7,0-.95,0-4.58-.06-6.73"
        />
        <line class="cls-3" x1="8.68" y1="10.72" x2="24.16" y2="10.72" />
        <line class="cls-3" x1="8.68" y1="14.79" x2="24.16" y2="14.79" />
        <line class="cls-3" x1="8.68" y1="19.77" x2="14.14" y2="19.77" />
        <circle class="cls-4" cx="29.29" cy="7.11" r="1.5" />
        <line class="cls-3" x1="25.75" y1="23.25" x2="25.75" y2="31.63" />
        <rect
          class="cls-3"
          x="21.87"
          y="25.47"
          width="7.75"
          height="2.99"
          rx="0.91"
        />
      </g>
    </g>
  </svg>
  <svg
    v-if="modelValue == 2"
    class="completed"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.2 38.14"
  >
    <title>资源 154</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="29.55" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="29.55" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M28.68,3.38V3a1.93,1.93,0,0,0-2-1.86H7.25A1.94,1.94,0,0,0,5.25,3V29.38a1.94,1.94,0,0,0,2,1.87H18.36a.27.27,0,0,0,.28-.35c-.52-1.46-2.2-7,1.35-10A9.48,9.48,0,0,1,28.68,19c.07,0,.16-.23.16-.69,0-.94,0-4.55-.07-6.69"
        />
        <line class="cls-3" x1="8.29" y1="7.63" x2="23.68" y2="7.63" />
        <line class="cls-3" x1="8.29" y1="12.93" x2="23.68" y2="12.93" />
        <line class="cls-3" x1="8.29" y1="18.23" x2="13.72" y2="18.23" />
        <line class="cls-3" x1="25.08" y1="23.04" x2="25.08" y2="31.37" />
        <rect
          class="cls-3"
          x="21.23"
          y="25.26"
          width="7.71"
          height="2.97"
          rx="0.91"
        />
        <circle class="cls-4" cx="28.84" cy="7.07" r="1.49" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
    }
    .cls-3 {
      stroke-width: 2.1px;
    }
    .cls-4 {
      stroke-width: 2.17px;
    }
    .cls-5 {
      stroke-width: 1.5px;
    }
    .cls-6 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.29px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
      stroke: #1ca586;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.28px;
    }
    .cls-4 {
      fill: #1ca586;
    }
  }
</style>
